/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Parameters for cancelling empty meetings before booking cutoff.

cutoff_hours: number of hours before start within which students effectively
will no longer book; meetings without bookings in this window are cancelled.
Default aligns with the 24-hour cancellation policy.
 */
export interface MeetingsEmptySlotsCancelParams {
  cutoffHours?: number;
}
